












import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/private/AuthHeader.vue";
import SideNav from "@/components/private/SideNav.vue";

@Component({
  components: { AuthHeader, SideNav }
})
export default class AuthHome extends Vue {
  refreshKey = 0;
  sideBarActive: boolean = true;
  showMenu: boolean = true;
  //Adaptação para forçar a navegação ao utilizar os links no menu
  routeParam(route: any) {
    this.refreshKey++;
    if (this.$route.path != "/auth/home-page") {
      this.$router.replace("/auth/home-page").then(() => {
        this.$router.push(route);
      });
    } else {
      this.$router.push(route);
    }
  }
  mounted() {
    if (window.location.href.includes("sid")) {
      this.showMenu = false;
    } else {
      this.showMenu = true;
    }
  }
  setSideBarActive(active: boolean) {
    this.sideBarActive = active;
  }
}
